import { createTheme } from '@mui/material/styles';
import { components, palette, typography } from '@utriper/core-ui';

import overrides from './overrides';

// palette, typography and components are @utriper/core-ui's, generated from the design system's tokens.json
// (com.utriper.core-ui/design-system, `npm run gen:theme`). `overrides` is this app's own legacy block; it is
// passed as before (MUI 5 ignores it without adaptV4Theme — pre-existing, tracked separately, not changed here).
export default createTheme({
  palette,
  typography,
  components,
  overrides,
  inputs: {
    minHeight: 104,
  },
});
